import React from 'react';
import vineImage from './assets/vine.png';
import lyftImage from './assets/lyft.png';
import googleImage from './assets/google.png';
import disneyImage from './assets/disney.png';
import gatechImage from './assets/gatech.png';
import volantioImage from './assets/volantio.png';
import oracleImage from './assets/oracle.png';
import foursquareImage from './assets/foursquare.png';
import getaroundImage from './assets/getaround.png';
import questImage from './assets/quest.png';
import targetImage from './assets/target.png';
import southwestImage from './assets/southwest.png';
import nikeImage from './assets/nike.png';
import vansImage from './assets/vans.png';
import chickfilaImage from './assets/chickfila.png';
import uberImage from './assets/uber.png';
import styles from './styles.scss';

function Repertoire () {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <h4 className={`bold text-center demi-bold blue ${styles.repHeading}`}>Our Designers have worked with these awesome companies:</h4>
          <RepertoireImages />
        </div>
      </div>
    </div>
  );
}

function RepertoireImages () {
  return (
    <div id="repertoire" className="carousel slide" data-ride="carousel">
      <div className="carousel-inner" role="listbox">
        <div className="item active text-center">
          <div className="row">
            <div className={`${styles.colEighth} col-xs-3`}>
              <img className={styles.repImg} src={vineImage} alt="airbnb" />
            </div>
            <div className={`${styles.colEighth} col-xs-3`}>
              <img className={styles.repImg} src={lyftImage} alt="lyft" />
            </div>
            <div className={`${styles.colEighth} col-xs-3`}>
              <img className={styles.repImg} src={googleImage} alt="google" />
            </div>
            <div className={`${styles.colEighth} col-xs-3`}>
              <img className={styles.repImg} src={disneyImage} alt="disney" />
            </div>
            <div className={`${styles.colEighth} col-xs-3`}>
              <img className={styles.repImg} src={gatechImage} alt="georgia tech" />
            </div>
            <div className={`${styles.colEighth} col-xs-3`}>
              <img className={styles.repImg} src={volantioImage} alt="volantio" />
            </div>
            <div className={`${styles.colEighth} col-xs-3`}>
              <img className={styles.repImg} src={oracleImage} alt="oracle" />
            </div>
            <div className={`${styles.colEighth} col-xs-3`}>
              <img className={styles.repImg} src={foursquareImage} alt="foursquare" />
            </div>
            <div className={`${styles.colEighth} col-xs-3`}>
              <img className={styles.repImg} src={getaroundImage} alt="getaround" />
            </div>
            <div className={`${styles.colEighth} col-xs-3`}>
              <img className={styles.repImg} src={questImage} alt="quest" />
            </div>
            <div className={`${styles.colEighth} col-xs-3`}>
              <img className={styles.repImg} src={targetImage} alt="target" />
            </div>
            <div className={`${styles.colEighth} col-xs-3`}>
              <img className={styles.repImg} src={southwestImage} alt="southwest" />
            </div>
            <div className={`${styles.colEighth} col-xs-3`}>
              <img className={styles.repImg} src={nikeImage} alt="nike" />
            </div>
            <div className={`${styles.colEighth} col-xs-3`}>
              <img className={styles.repImg} src={vansImage} alt="vans" />
            </div>
            <div className={`${styles.colEighth} col-xs-3`}>
              <img className={styles.repImg} src={chickfilaImage} alt="chick-fil-a" />
            </div>
            <div className={`${styles.colEighth} col-xs-3`}>
              <img className={styles.repImg} src={uberImage} alt="uber" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Repertoire;
export { RepertoireImages };



// WEBPACK FOOTER //
// ./src/components/Repertoire/index.js